/**
 * PrivacyPolicyPage component
 * Requirements: 10.3 - Display privacy policy
 */
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider,
} from '@mui/material';

interface PolicySection {
  title: string;
  content: React.ReactNode;
}

const policySections: PolicySection[] = [
  {
    title: '収集するデータ',
    content: (
      <>
        <Typography variant="body2" paragraph>
          当サービスでは、以下の種類のデータを収集します:
        </Typography>
        <Box component="ul" sx={{ mt: 0 }}>
          <li>
            <Typography variant="body2">
              アカウント情報(メールアドレス、氏名)
            </Typography>
          </li>
          <li>
            <Typography variant="body2">質問への回答データ</Typography>
          </li>
          <li>
            <Typography variant="body2">思考傾向分析の結果</Typography>
          </li>
          <li>
            <Typography variant="body2">利用ログ(アクセス日時等)</Typography>
          </li>
        </Box>
      </>
    ),
  },
  {
    title: 'データの使用目的',
    content: (
      <Box component="ul" sx={{ mt: 0 }}>
        <li>
          <Typography variant="body2">
            思考傾向分析サービスの提供
          </Typography>
        </li>
        <li>
          <Typography variant="body2">サービスの品質向上と改善</Typography>
        </li>
        <li>
          <Typography variant="body2">ユーザーサポートの提供</Typography>
        </li>
        <li>
          <Typography variant="body2">セキュリティの維持</Typography>
        </li>
      </Box>
    ),
  },
  {
    title: 'データの保管',
    content: (
      <Typography variant="body2">
        収集したデータは、適切なセキュリティ対策を施したサーバーに保管されます。
        データは暗号化され、許可されたスタッフのみがアクセスできます。
      </Typography>
    ),
  },
  {
    title: 'データの共有',
    content: (
      <Typography variant="body2">
        法律で要求される場合を除き、ユーザーの個人データを第三者と共有することはありません。
        組織内での分析機能は、許可されたユーザーのみが利用できます。
      </Typography>
    ),
  },
  {
    title: 'ユーザーの権利',
    content: (
      <>
        <Typography variant="body2" paragraph>
          ユーザーには以下の権利があります:
        </Typography>
        <Box component="ul" sx={{ mt: 0 }}>
          <li>
            <Typography variant="body2">
              データへのアクセス: 自分のデータを確認できます
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              データのエクスポート: 個人データをJSON形式でダウンロードできます
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              アカウントの削除: アカウントと関連データを完全に削除できます
            </Typography>
          </li>
        </Box>
      </>
    ),
  },
  {
    title: 'お問い合わせ',
    content: (
      <Typography variant="body2">
        プライバシーに関するお問い合わせは、管理者までご連絡ください。
      </Typography>
    ),
  },
];

export const PrivacyPolicyPage = () => {
  const lastUpdated = '2024年1月1日';

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          プライバシーポリシー
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          最終更新日: {lastUpdated}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {policySections.map((section, index) => (
          <Box key={section.title} sx={{ mb: index < policySections.length - 1 ? 3 : 0 }}>
            <Typography variant="h6" gutterBottom>
              {section.title}
            </Typography>
            {section.content}
          </Box>
        ))}
      </Paper>
    </Container>
  );
};
